import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useQueryWithErrorHandling } from '../../../customHooks/errorHandling';
import { GET_OFFER_STEPS_QUERY } from './queries/offerWizzardQueries';
import { getInt, isValidNumber } from '../../../utils/functions';
import OfferWizard from './OfferWizard';
import { OFFER_STEPS_CHANGED } from './subscriptions/offerWizzardSubscriptions';
import { useGlobalSubscription } from '../../../providers/GlobalCacheManager';

const OfferStepperContainer = props => {
  const { offerHeader, locationPathname, newOffer } = props;
  const { documentId, siteId, history } = props;

  const [documentStepsConfig, setDocumentStepsConfig] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [stepsRefetching, setStepsRefetching] = useState(false);

  const { loading: documentStepsConfigLoading, refetch: refetchDocumentSteps } = useQueryWithErrorHandling(GET_OFFER_STEPS_QUERY, {
    variables: {
      documentId: getInt(documentId),
      siteId: getInt(siteId),
      documentTypeId: getInt(offerHeader.documentTypeId),
      offerTypeId: getInt(offerHeader.offerTypeId)
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      setActiveStep(data.getOfferSteps.activeStep);
      setDocumentStepsConfig(data.getOfferSteps);
      setStepsRefetching(false);
    }
  });

  useGlobalSubscription(OFFER_STEPS_CHANGED, {
    skip: !isValidNumber(documentId) || !isValidNumber(siteId),
    variables: { documentId: parseInt(documentId), siteId: parseInt(siteId) },
    onSubscriptionData: _ => {
      refetchDocumentSteps();
      setStepsRefetching(true);
    }
  });

  const onChangeActiveStep = value => {
    setActiveStep(value);
  };

  return (
    documentStepsConfig !== null &&
    (!documentStepsConfigLoading || stepsRefetching) && (
      <OfferWizard
        documentId={documentId}
        siteId={siteId}
        newOffer={newOffer}
        offerHeader={offerHeader}
        locationPathname={locationPathname}
        history={history}
        activeStep={activeStep}
        steps={documentStepsConfig.steps}
        onChangeActiveStep={onChangeActiveStep}
      />
    )
  );
};

OfferStepperContainer.propTypes = {
  offerHeader: PropTypes.object,
  locationPathname: PropTypes.string,
  history: PropTypes.object.isRequired,
  documentId: PropTypes.string,
  siteId: PropTypes.string,
  newOffer: PropTypes.string
};
export default withRouter(OfferStepperContainer);
